<template>

  <v-card color="white" class="card-border">
    <v-system-bar height="45" window color="itoviGrayLight">
      <h2 class="card-header-text">Payment Information</h2>
      <v-spacer></v-spacer>
    </v-system-bar>

    <div v-if="!!credit_card_info">
      <CreditCardDialog v-if="showUpdateCcDialog" v-model="showUpdateCcDialog"></CreditCardDialog>
      <BillingHistoryDialog v-if="showBillingHistoryDialog" v-model="showBillingHistoryDialog" :history="billing_history" ></BillingHistoryDialog>
    </div>

    <div v-if="!(!!credit_card_info)" class="pa-4">
      <v-progress-linear :indeterminate="true"></v-progress-linear>
    </div>
    <div class="card-body" v-if="!!credit_card_info">


      <!-- CC info               -->
      <v-layout align-center row wrap>
        <span class="txt-bold">Card Info</span>
        <v-spacer></v-spacer>
        <v-btn small flat color="accent" class="txt-bold"
               @click="showUpdateCcDialog = true">Update
        </v-btn>
      </v-layout>


      <div v-if="!credit_card_info.last_four">No card on file</div>

      <div v-if="credit_card_info.last_four">Card ending in {{ credit_card_info.last_four}}</div>
      <div v-if="credit_card_info.exp">Expires {{ credit_card_info.exp}}</div>

      <v-divider class="mt-4 mb-3"></v-divider>

      <!-- Billing History               -->
      <v-layout align-center row wrap>
        <span class="txt-bold">Billing History</span>
        <v-spacer></v-spacer>
        <v-btn small flat color="accent" class="txt-bold"
               @click="showBillingHistoryDialog = true">View
        </v-btn>
      </v-layout>


    </div>

  </v-card>

</template>

<script>
  import api from "../../../services/api_endpoints";
  import store from '../../../store'
  import CreditCardDialog from "./CreditCardDialog"
  import BillingHistoryDialog from "./BillingHistoryDialog"

  export default {
    components: {
      CreditCardDialog,
      BillingHistoryDialog,
    },
    data: ()=> ({
      credit_card_info: store.state.ccInfo,
      showUpdateCcDialog: false,
      showBillingHistoryDialog: false,
      billing_history: store.state.billingHistory
    }),
    props: {
      onLoaded: Function,
    },
    created(){
      this.fetchData()
    },
    mounted() {
      // subscribe to changes on the 'setCcInfo' store mutation
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'setCcInfo') {
          // console.log(`Updating setCcInfo - ${state}`);
          this.credit_card_info = state.ccInfo
        } else if (mutation.type === 'setBillingHistory') {
          // console.log(`Updating setBillingHistory - ${state}`);
          this.billing_history = state.billingHistory
        }
      })
    },
    methods: {
      isFunction(functionToCheck) {
        return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
      },
      async fetchData() {
        this.credit_card_info = await api.getCcInfo()
        this.billing_history = await api.getBillingHistory()
        if (this.isFunction(this.onLoaded)) this.onLoaded()
      },
    },
  }
</script>
